<template>
  <v-card class="card-stats card-body" :show-footer-line="true">
    <div class="row">
      <div class="col py-0">
        <slot>
          <v-list-item-title v-if="title" class="mb-3 list-item-title">{{title}}</v-list-item-title>
          <v-list-item>
            <v-list-item-title v-if="subTitle">
              <h1 class="ml-10 mb-0 list-item-subtitle" :class="[`color-${type}`]">{{subTitle}}</h1>
            </v-list-item-title>
            <router-link :to="{ path: `${url}` }">
              <img src="@/assets/images/Navigation.svg" />
            </router-link>
          </v-list-item>
        </slot>
      </div>

      <div class="col-auto" v-if="$slots.icon || icon">
        <slot name="icon">
          <div
            class="icon icon-shape text-white rounded-circle shadow"
            :class="[`bg-${type}`, iconClasses]"
          >
            <i :class="icon"></i>
          </div>
        </slot>
      </div>
    </div>

    <p class="mt-3 mb-0 text-sm">
      <slot name="footer"></slot>
    </p>
  </v-card>
</template>
<script>

export default {
  name: "stats-card",
  props: {
    type: {
      type: String,
      default: "primary",
    },
    url: String,
    icon: String,
    title: String,
    subTitle: Number,
    iconClasses: [String, Array],
  },
};
</script>

<style lang="scss" scoped>
.list-item-title {
  font-size: 19px;
  font-weight: 500;
  color: #344452;
}
.list-item-subtitle {
  font-size: 32px;
}
.color-black {
  color: #344452;
}
.color-green {
  color: #3D9E41;
}
.color-yellow {
  color: #FDAF19;
}
</style>